<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <!-- /app-payment-form -->
        <app-payment-form
          [amountInCents]="amountInCents"
          [reference]="reference"
        >
        </app-payment-form>
        <!-- /app-payment-form -->
        <div class="invoice-title">
          <div class="d-flex align-items-start">
            <div class="flex-grow-1">
              <div class="mb-4">
                <img
                  src="assets/images/Logo_horizontal-blanco.png"
                  alt=""
                  height="120"
                />
              </div>
            </div>
            <div class="flex-shrink-0">
              <div class="mb-4">
                <h4 class="float-end font-size-16">
                  Referencia # {{ idPaquete }}
                </h4>
              </div>
            </div>
          </div>
          <p class="mb-1">Sede Chicó/Antiguo Country Cra. 16 # 80 - 77</p>
          <p class="mb-1">
            <i class="mdi mdi-email align-middle me-1"></i>
            agenda&#64;psicologa.co
          </p>
          <p><i class="mdi mdi-phone align-middle me-1"></i> +57 314 8131016</p>
        </div>
        <hr class="my-4" />
        @if(datosPaciente){
        <div class="row">
          <div class="col-sm-6">
            <div>
              <h5 class="font-size-15 mb-3">Facturado a:</h5>
              <h5 class="font-size-14 mb-2">
                {{ datosPaciente.nombres }} {{ datosPaciente.apellidos }}
              </h5>
              <p class="mb-1">{{ datosPaciente.direccionResidencia }}</p>
              <p class="mb-1">{{ datosPaciente.email }}</p>
              <p>{{ datosPaciente.celular }}</p>
            </div>
          </div>
          <div class="col-sm-6">
            <div>
              <div>
                <h5 class="font-size-15">Fecha:</h5>
                <p>{{ date | date : "dd/MM/yyyy" }}</p>
              </div>
            </div>
          </div>
        </div>
        }
        <div class="py-2 mt-3">
          <h5 class="font-size-15">Resumen del pedido</h5>
        </div>
        @if(datosPaquete){
        <div class="p-4 border rounded">
          <div class="table-responsive">
            <table class="table table-nowrap align-middle mb-0">
              <thead>
                <tr>
                  <th style="width: 70px">No.</th>
                  <th>Servicio</th>

                  <th class="text-end" style="width: 120px">Precio</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">01</th>
                  <td>
                    <h5 class="font-size-15 mb-1">
                      {{ datosPaquete.servicio }}
                    </h5>
                    <p class="font-size-13 text-muted mb-0">
                      {{ datosPaquete.cantidad_citas }} Sesiones
                    </p>
                  </td>
                  @if(userLocal){
                  <td class="text-end">
                    {{
                      datosPaquete.valorCop
                        | currency : "COP $" : true : "1.2-2"
                    }}
                  </td>
                  }@else{
                  <td class="text-end">
                    {{
                      datosPaquete.valorCop
                        | currency : "USD $" : true : "1.2-2"
                    }}
                  </td>
                  }
                </tr>

                <tr>
                  <th scope="row" colspan="2" class="text-end">Sub Total</th>
                  @if(userLocal){
                  <td class="text-end">
                    {{
                      datosPaquete.valorCop
                        | currency : "COP $" : true : "1.2-2"
                    }}
                  </td>
                  }@else{

                  <td class="text-end">
                    {{
                      datosPaquete.valorCop
                        | currency : "USD $" : true : "1.2-2"
                    }}
                  </td>
                  }
                </tr>

                <!-- <tr>
                                    <th scope="row" colspan="2" class="border-0 text-end"> Tax</th>
                                    <td class="border-0 text-end">$12.00</td>
                                </tr> -->
                <tr>
                  <th scope="row" colspan="2" class="border-0 text-end">
                    Total
                  </th>
                  <td class="border-0 text-end">
                    @if(userLocal){
                    <h4 class="m-0">
                      {{
                        datosPaquete.valorCop
                          | currency : "COP $" : true : "1.2-2"
                      }}
                    </h4>
                    }@else{
                    <h4 class="m-0">
                      {{
                        datosPaquete.valorCop
                          | currency : "USD $" : true : "1.2-2"
                      }}
                    </h4>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        }
        <div class="d-print-none mt-3">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-success waves-effect waves-light me-1"
              ><i class="fa fa-print"></i></a
            ><a
              (click)="comprarPaquete()"
              class="btn btn-info w-md waves-effect waves-light"
              >Ir a Pagar</a
            >
          </div>
        </div>
      </div>
      <div class="card-footer">
        <img src="assets/images/metodo-de-pago-wompi.png" width="100%" />
      </div>
    </div>
  </div>
</div>
